import { defineAction, enumerated, expression } from '~/prix'
import { z } from 'zod'
import semenBatchListAction from './semenBatchList.action.json' with { type: 'json' }
import { semenBatchObject } from '../semenBatchObject'
import { bullObject } from '../../bull/bullObject'

const semenBatchExpression = expression(semenBatchObject.shape)

const semenBatchListDefinition = defineAction({
  ...semenBatchListAction,

  input: z.object({
    filter: semenBatchExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      bullId: 'Identificador do touro',
      quantity: 'Quantidade',
      type: 'Tipo',
      semenType: 'Tipo de sêmen',
      supplier: 'Fornecedor',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
  }),
  output: z.object({
    items: z.array(
      semenBatchObject.extend({
        bull: bullObject,
      }),
    ),
    count: z.number(),
  }),
})

export default semenBatchListDefinition
